import * as toastr from 'toastr';

declare const window: Window &
    typeof globalThis & {
        toastr: any
    }

window.toastr = toastr;

interface ToasterOptions {
    closeButton?: boolean,
    title?: string,
    onlyUserCanHide?: boolean,
    position?: string,
    timeOut?: number,
    positionClass?: string,
    preventDuplicates?: boolean,
    okAction?: (e: any) => void,
    cancelAction?: (e: any) => void,
    onHidden?: (e: any) => void,
}

const ToasterService = {

    showToaster: function (options: ToasterOptions, toasterType: string) {
        var title = options.title,
            $toast;

        toastr.options = {
            closeButton: true,
            closeHtml: '<i class="icon icon-alan-remove"></i>',
            showDuration: '5000',
            hideDuration: '1000',
            showEasing: 'swing',
            hideEasing: 'linear',
            showMethod: 'fadeIn',
            hideMethod: 'fadeOut',
            timeOut: options.timeOut || 15000,
            positionClass: 'toast-top-right',
            preventDuplicates: options.preventDuplicates || false,
            onHidden: options.onHidden || undefined,
        };

        if (options.onlyUserCanHide || toasterType === 'error') {
            toastr.options.timeOut = 0;
            toastr.options.extendedTimeOut = 0;
        }

        if (options.position) {
            toastr.options.positionClass = `${toastr.options.positionClass} toast-${options.position}`;
        }
        
        $toast = toastr[toasterType](title);

        if (typeof $toast === 'undefined') {
            return;
        }

        if (options.okAction && $toast.find('#ok').length) {
            $toast.delegate('#ok', 'click', function (e) {
                options.okAction(e);
            });
        }
        if (options.cancelAction && $toast.find('#cancel').length) {
            $toast.delegate('#cancel', 'click', function (e) {
                options.cancelAction(e);
            });
        }
        if ($toast.find('#close').length) {
            $toast.delegate('#close', 'click', function (e) {
                toastr.clear();
            });
        }
    },

    showError: function (options: ToasterOptions) {
        return this.showToaster(options, 'error');
    },

    showWarning: function (options: ToasterOptions) {
        return this.showToaster(options, 'warning');
    },

    showInfo: function (options: ToasterOptions) {
        return this.showToaster(options, 'info');
    },

    clear: function () {
        toastr.clear();
    }
};

export default ToasterService;